module.exports = __webpack_public_path__ + "img/home_faculty.6f1fed27.jpg";